//@flow

import {
  getPopupBannerApi,
  createPopupBannerApi,
  deletePopupBannerApi,
  toggleEnabledPopupBannerApi,
  endpoints,
} from '../api/popup-banner';

import type {CreatePopupBannerRequest} from '../api/popup-banner';
import type {PopupBanner} from '../../../entities';
import {buildRoute} from '../../../http';

export function getPopupBanners(): Promise<PopupBanner[]> {
  return getPopupBannerApi().toPromise();
}

export function createPopupBanner(
  payload: CreatePopupBannerRequest
): Promise<PopupBanner> {
  return createPopupBannerApi(payload).toPromise();
}

export function deletePopupBanner(id: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_POPUP_BANNER, [id]);

  return deletePopupBannerApi({route}).toPromise();
}

export function toggleEnabledPopupBannerService(
  id: string,
  enabled: boolean
): Promise<void> {
  const route = buildRoute(endpoints.TOGGLE_ENABLED_POPUP_BANNER, [id]);

  return toggleEnabledPopupBannerApi({enabled}, {route}).toPromise();
}
